import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useEffect, useRef, useMemo, useCallback } from "react";

import Landing from "./pages/Landing";
import Loading from "./pages/Loading";
import BackgroundMusic from "./components/BackgroundMusic";
import Home from "./pages/Home";
import Food from "./pages/FoodGame";
import Languages from "./pages/languages";
import Clothing from "./pages/Clothes";
import Landmarks from "./pages/landmarks";
import Animals from "./pages/Animals";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Reset from "./pages/Reset";
import ClothesQuiz from "./pages/ClothesQuiz";
import FoodQuiz from "./pages/FoodQuiz";
import LanguagesQuiz from "./pages/LanguagesQuiz";
import LandmarksQuiz from "./pages/LandmarksQuiz";
import AnimalsQuiz from "./pages/AnimalsQuiz";

function ProtectedRoute({ children }) {
  const savedUser = localStorage.getItem("exploreLankaUser");

  if (!savedUser) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef(null);

  const publicPaths = useMemo(
    () => ["/", "/login", "/register", "/reset"],
    []
  );

  const resetTimer = useCallback(() => {
    clearTimeout(timeoutRef.current);

    const savedUser = localStorage.getItem("exploreLankaUser");
    if (!savedUser) return;

    timeoutRef.current = setTimeout(() => {
      localStorage.removeItem("exploreLankaUser");
      navigate("/", { replace: true });
    }, 30 * 60 * 1000);
  }, [navigate]);

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "touchstart"];

    const handleActivity = () => {
      if (!publicPaths.includes(location.pathname)) {
        resetTimer();
      }
    };

    events.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    if (!publicPaths.includes(location.pathname)) {
      resetTimer();
    }

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );

      clearTimeout(timeoutRef.current);
    };
  }, [location.pathname, publicPaths, resetTimer]);

  return (
    <>
      <BackgroundMusic />

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset" element={<Reset />} />

        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/food"
          element={
            <ProtectedRoute>
              <Food />
            </ProtectedRoute>
          }
        />

        <Route
          path="/languages"
          element={
            <ProtectedRoute>
              <Languages />
            </ProtectedRoute>
          }
        />

        <Route
          path="/clothing"
          element={
            <ProtectedRoute>
              <Clothing />
            </ProtectedRoute>
          }
        />

        <Route
          path="/landmarks"
          element={
            <ProtectedRoute>
              <Landmarks />
            </ProtectedRoute>
          }
        />

        <Route
          path="/animals"
          element={
            <ProtectedRoute>
              <Animals />
            </ProtectedRoute>
          }
        />

        <Route
          path="/clothesquiz"
          element={
            <ProtectedRoute>
              <ClothesQuiz />
            </ProtectedRoute>
          }
        />

        <Route
          path="/foodquiz"
          element={
            <ProtectedRoute>
              <FoodQuiz />
            </ProtectedRoute>
          }
        />

        <Route
          path="/languagesquiz"
          element={
            <ProtectedRoute>
              <LanguagesQuiz />
            </ProtectedRoute>
          }
        />

        <Route
          path="/landmarksquiz"
          element={
            <ProtectedRoute>
              <LandmarksQuiz />
            </ProtectedRoute>
          }
        />

        <Route
          path="/animalsquiz"
          element={
            <ProtectedRoute>
              <AnimalsQuiz />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default AppContent;